




















import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'FilesUpdown'
})
export default class extends Vue {

}
